import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getMemberMeasures = (memberMpiNo: string, provKey: string, companyId: string, lob: string, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_MEASURES_REQUEST });

  if (lob === 'ALL') lob = '';

  return api.authorization.hcc.getMemberMeasures(memberMpiNo, provKey, companyId, lob, userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_MEASURES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_MEASURES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const addMemberDocsToHccDocs = (hccRmiUid: string, memberDocIds: Array<string>, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authHCC.isAdding) { return Promise.reject(); }

  dispatch({ type: types.ADD_TO_HCC_DOCS_REQUEST });

  const hccIdAndMemberDocsObj = {
    HccRmiUid: hccRmiUid,
    MemberDocIds: memberDocIds,
    CreatedBy: userId
  };

  return api.authorization.hcc.addMemberDocsToHccDocs(hccIdAndMemberDocsObj)
    .then((res: any) => {

      dispatch({
        type: types.ADD_TO_HCC_DOCS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.ADD_TO_HCC_DOCS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const printProviderMemberReport = (provKey: string, companyId: string, lob: string, userId: string)=> (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_REQUEST });

  if (lob === 'ALL') lob = '';
  const materials = {
    CompanyId: companyId,
    RmiProvKeyId: provKey,
    Lob: lob,
    UserId: userId
  }

  return api.authorization.hcc.printProviderMemberReport(materials)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  